import axios from 'axios'
import { getBorrowToken } from '@/utils/get_toB_token'
import { setToken, removeToken } from '@/utils/auth'
import store from '@/store'

let isRefreshing = false // 标记是否正在刷新 token
let requests = [] // 存储待重发请求的数组
const getCID = () => {
  let cid = window.location.pathname.replace('/org/', '')
  if (cid.indexOf('/') !== -1) {
    cid = cid.split('/')[0]
  }
  return cid
}

const audioService = axios.create({
  baseURL: process.env.VUE_BASE_API,
  withCredentials: false,
  timeout: 15000 // request timeout
})

audioService.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

audioService.interceptors.response.use(

  response => {
    const res = response

    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 200) {
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (!error.response) {
      return Promise.reject(error)
    }
    if (error.response.status === 401 && !error.config.url.includes('/lambda/createcustom')) {
      const { config } = error
      if (!isRefreshing) {
        const cid = getCID()
        isRefreshing = true
        return store.dispatch('toB/getClientInfo', cid)
          .then((res) => {
            return res.id
          })
          .then((id) => {
            return getBorrowToken(id)
          })
          .then((token) => {
            // console.log(token)
            console.log('刷新Token')
            store.dispatch('toB/setClientToken', token)
            const cid = store.state.toB.cid

            setToken(token, cid)
            config.headers.Authorization = `Bearer ${token}`
            requests.forEach((cb) => cb(token))
            requests = [] // 重新请求完清空
            return audioService(config)
          })
          .catch(err => {
            console.log('刷新Token失敗')
            const cid = store.state.toB.cid
            removeToken(cid)
            window.location.reload()
            return Promise.reject(err)
          }).finally(() => {
            isRefreshing = false
          })
      } else {
        // 返回未执行 resolve 的 Promise
        return new Promise(resolve => {
          // 用函数形式将 resolve 存入，等待刷新后再执行
          requests.push(token => {
            config.headers.Authorization = `Bearer ${token}`
            resolve(audioService(config))
          })
        })
      }
    }
    console.log(error.response)
    return Promise.reject(error)
  }
)

export default audioService



// WEBPACK FOOTER //
// ./src/utils/audioRequest.js